    <div
      class="pointer-events-none fixed end-0 top-0 z-[1200] flex max-w-sm flex-col gap-2 p-3"
      aria-live="polite"
    >
      @for (toast of notificationService.toasts(); track toast) {
        <div
          class="pointer-events-auto flex w-full min-w-[280px] flex-col overflow-hidden rounded-panel border text-sm shadow-panel"
          [class]="getToastContainerClass(toast)"
          role="status"
        >
          <div
            class="flex items-center justify-between border-b px-3 py-2 text-xs font-semibold uppercase tracking-wide"
            [class]="getToastHeaderClass(toast)"
          >
            <span>{{ getToastHeader(toast) }}</span>
            <button
              type="button"
              class="rounded p-0.5 opacity-80 hover:opacity-100"
              (click)="onToastHidden(toast)"
              [attr.aria-label]="'Dismiss ' + getToastHeader(toast)"
            >
              &times;
            </button>
          </div>
          <div class="px-3 py-2" [class]="getToastBodyClass(toast)">
            {{ toast.message }}
          </div>
        </div>
      }
    </div>
  
